import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2a7450ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "card"
}
const _hoisted_2 = { class: "card-header border-0 pt-6" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "me-4" }
const _hoisted_5 = { class: "card-toolbar" }
const _hoisted_6 = {
  class: "d-flex justify-content-end p-1",
  "data-kt-customer-table-toolbar": "base"
}
const _hoisted_7 = {
  key: 0,
  class: "d-flex justify-content-end align-items-center p-1",
  "data-kt-customer-table-toolbar": "selected"
}
const _hoisted_8 = { class: "fw-bolder me-5" }
const _hoisted_9 = { class: "me-2" }
const _hoisted_10 = { class: "indicator-label" }
const _hoisted_11 = { class: "indicator-progress" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_13 = {
  key: 1,
  class: "d-flex justify-content-end align-items-center p-1",
  "data-kt-customer-table-toolbar": "selected"
}
const _hoisted_14 = { class: "fw-bolder me-5" }
const _hoisted_15 = { class: "me-2" }
const _hoisted_16 = { class: "indicator-label" }
const _hoisted_17 = { class: "indicator-progress" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_19 = { class: "d-flex justify-content-end p-1" }
const _hoisted_20 = { class: "svg-icon svg-icon-2" }
const _hoisted_21 = { class: "card-body pt-0 compact-table" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "symbol symbol-45px me-5" }
const _hoisted_24 = ["src", "onClick"]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = {
  class: "modal fade",
  tabindex: "-1",
  id: "kt_modal_1"
}
const _hoisted_27 = { class: "modal-dialog" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = {
  key: 1,
  class: "modal-content"
}
const _hoisted_32 = { class: "modal-header" }
const _hoisted_33 = { class: "modal-title" }
const _hoisted_34 = { class: "card-body p-5" }
const _hoisted_35 = { class: "mb-0" }
const _hoisted_36 = { class: "mb-4" }
const _hoisted_37 = { class: "d-flex flex-wrap py-5" }
const _hoisted_38 = { class: "flex-equal me-5" }
const _hoisted_39 = { class: "table fs-6 fw-bold gs-0 gy-2 gx-2 m-0" }
const _hoisted_40 = { class: "text-gray-400 min-w-175px w-175px" }
const _hoisted_41 = { class: "text-gray-800 min-w-200px" }
const _hoisted_42 = { class: "text-gray-400 min-w-175px w-175px" }
const _hoisted_43 = { class: "text-gray-800" }
const _hoisted_44 = { class: "text-gray-400 min-w-175px w-175px" }
const _hoisted_45 = { class: "text-gray-800" }
const _hoisted_46 = { class: "text-gray-400 min-w-175px w-175px" }
const _hoisted_47 = { class: "text-gray-800" }
const _hoisted_48 = { key: 0 }
const _hoisted_49 = { class: "text-gray-400 min-w-175px w-175px" }
const _hoisted_50 = { class: "text-gray-800" }
const _hoisted_51 = { class: "text-gray-400 min-w-175px w-175px" }
const _hoisted_52 = { class: "text-gray-800" }
const _hoisted_53 = { class: "text-gray-400 min-w-175px w-175px" }
const _hoisted_54 = { class: "text-gray-800" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_56 = { class: "mb-4" }
const _hoisted_57 = { class: "text-gray-400 min-w-175px w-175px" }
const _hoisted_58 = { class: "text-gray-800" }
const _hoisted_59 = { class: "text-gray-400 min-w-175px w-175px" }
const _hoisted_60 = { class: "text-gray-800" }
const _hoisted_61 = { class: "text-gray-400 min-w-175px w-175px" }
const _hoisted_62 = { class: "text-gray-800" }
const _hoisted_63 = { class: "text-gray-400 min-w-175px w-175px" }
const _hoisted_64 = { class: "text-gray-800" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-footer" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-light",
    "data-bs-dismiss": "modal"
  }, " Close ")
], -1))
const _hoisted_66 = {
  key: 0,
  class: "badge badge-light-warning"
}
const _hoisted_67 = {
  key: 1,
  class: "badge badge-light-success"
}
const _hoisted_68 = {
  key: 2,
  class: "badge badge-light-primary"
}
const _hoisted_69 = {
  key: 3,
  class: "badge badge-light-danger"
}
const _hoisted_70 = {
  key: 4,
  class: "badge badge-light-info"
}
const _hoisted_71 = { class: "d-flex align-items-center flex-nowrap" }
const _hoisted_72 = ["onClick"]
const _hoisted_73 = { class: "svg-icon svg-icon-3" }
const _hoisted_74 = ["onClick"]
const _hoisted_75 = { class: "svg-icon svg-icon-3" }
const _hoisted_76 = ["onClick"]
const _hoisted_77 = { class: "svg-icon svg-icon-3" }
const _hoisted_78 = ["onClick"]
const _hoisted_79 = { class: "svg-icon svg-icon-3" }
const _hoisted_80 = { class: "form-check form-check-sm form-check-custom form-check-solid ms-4" }
const _hoisted_81 = ["disabled", "value"]
const _hoisted_82 = { class: "row mb-6" }
const _hoisted_83 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_84 = { class: "col-lg-8 fv-row" }
const _hoisted_85 = { class: "row mb-6" }
const _hoisted_86 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_87 = { class: "col-lg-8 fv-row" }
const _hoisted_88 = { class: "fv-plugins-message-container" }
const _hoisted_89 = { class: "fv-help-block" }
const _hoisted_90 = { class: "card-footer d-flex justify-content-end py-6 px-9" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AdsAdvancedSearch = _resolveComponent("AdsAdvancedSearch")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.can('read', 'ads'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_AdsAdvancedSearch, {
                  onTypeSelected: _ctx.onTypeChange,
                  onReset: _ctx.onReset
                }, null, 8, ["onTypeSelected", "onReset"])
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                (_ctx.checkedAds.length > 0 && _ctx.can('update', 'ads'))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.checkedAds.length), 1),
                        _createTextVNode(_toDisplayString(_ctx.translate('selected')), 1)
                      ]),
                      _createElementVNode("button", {
                        type: "button",
                        ref: "bulkApproveButton",
                        class: "btn btn-danger",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openModal()))
                      }, [
                        _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.translate('rejectSelected')), 1),
                        _createElementVNode("span", _hoisted_11, [
                          _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                          _hoisted_12
                        ])
                      ], 512)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.checkedAds.length > 0 && _ctx.can('update', 'ads'))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.checkedAds.length), 1),
                        _createTextVNode(_toDisplayString(_ctx.translate('selected')), 1)
                      ]),
                      _createElementVNode("button", {
                        type: "button",
                        ref: "bulkApproveButton",
                        class: "btn btn-primary",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.approveAds()))
                      }, [
                        _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.translate('approveSelected')), 1),
                        _createElementVNode("span", _hoisted_17, [
                          _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                          _hoisted_18
                        ])
                      ], 512)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_19, [
                  (_ctx.can('create', 'ads'))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "btn btn-secondary",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goTo('ads-creating')))
                      }, [
                        _createElementVNode("span", _hoisted_20, [
                          _createVNode(_component_inline_svg, { src: "/media/icons/duotone/Navigation/Plus.svg" })
                        ]),
                        _createTextVNode(" " + _toDisplayString(_ctx.translate('addNewAds')), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_Datatable, {
              "table-data": _ctx.tableData,
              "table-header": _ctx.tableHeader,
              loading: _ctx.loading,
              "rows-per-page": 10,
              total: _ctx.totalItems,
              "enable-items-per-page-dropdown": false,
              onCurrentChange: _ctx.pageChanged
            }, {
              "cell-id": _withCtx(({ row: ad }) => [
                _createElementVNode("span", {
                  onClick: ($event: any) => (_ctx.viewAdCus(ad)),
                  style: _normalizeStyle({
              backgroundColor: ad.exists ? 'red' : '',
              color: ad.exists ? 'white' : '',
              cursor: ad.exists ? 'pointer' : '',
            })
                }, _toDisplayString(ad.id + (ad.exists ? `  ( ${ad.duplicateAdscount} )  ` : '')), 13, _hoisted_22)
              ]),
              "cell-thumbnail": _withCtx(({ row: ad }) => [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("img", {
                    src: ad.thumbnail,
                    alt: "",
                    style: {"cursor":"pointer"},
                    onClick: _withModifiers(($event: any) => (_ctx.viewAd(ad.id)), ["prevent"])
                  }, null, 8, _hoisted_24)
                ])
              ]),
              "cell-publishName": _withCtx(({ row: ad }) => [
                _createElementVNode("a", {
                  href: "#",
                  "data-bs-toggle": "modal",
                  "data-bs-target": "#kt_modal_1",
                  onClick: ($event: any) => (_ctx.showModal(ad))
                }, _toDisplayString(ad.publishName), 9, _hoisted_25),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    (_ctx.isload)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_28, _hoisted_30))
                      : _createCommentVNode("", true),
                    (!_ctx.isload)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                          _createElementVNode("div", _hoisted_32, [
                            _createElementVNode("h3", _hoisted_33, [
                              _createTextVNode(" user info #ID : "),
                              _createElementVNode("span", {
                                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.viewAdCusList(_ctx.modalUserData.id))),
                                style: {"cursor":"pointer","text-decoration":"underline"}
                              }, _toDisplayString(_ctx.modalUserData.id), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("div", _hoisted_35, [
                              _createElementVNode("h5", _hoisted_36, _toDisplayString(_ctx.translate('basicInfo')) + ":", 1),
                              _createElementVNode("div", _hoisted_37, [
                                _createElementVNode("div", _hoisted_38, [
                                  _createElementVNode("table", _hoisted_39, [
                                    _createElementVNode("tr", null, [
                                      _createElementVNode("td", _hoisted_40, _toDisplayString(_ctx.translate('name')) + ": ", 1),
                                      _createElementVNode("td", _hoisted_41, [
                                        _createElementVNode("span", {
                                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.viewAdCusList(_ctx.modalUserData.id))),
                                          style: {"cursor":"pointer","text-decoration":"underline"}
                                        }, _toDisplayString(_ctx.modalUserData.name), 1)
                                      ])
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _createElementVNode("td", _hoisted_42, _toDisplayString(_ctx.translate('adsCount')) + ": ", 1),
                                      _createElementVNode("td", _hoisted_43, [
                                        _createElementVNode("span", {
                                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.viewAdCusList(_ctx.modalUserData.id))),
                                          style: {"cursor":"pointer","text-decoration":"underline"}
                                        }, _toDisplayString(_ctx.modalUserData.adsCount), 1)
                                      ])
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _createElementVNode("td", _hoisted_44, _toDisplayString(_ctx.translate('duplicateAds')) + ": ", 1),
                                      _createElementVNode("td", _hoisted_45, _toDisplayString(_ctx.modalUserData.duplicateAds), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _createElementVNode("td", _hoisted_46, _toDisplayString(_ctx.translate('memberType')) + ": ", 1),
                                      _createElementVNode("td", _hoisted_47, _toDisplayString(_ctx.modalUserData.member_type), 1)
                                    ]),
                                    (_ctx.modalUserData.officeName)
                                      ? (_openBlock(), _createElementBlock("tr", _hoisted_48, [
                                          _createElementVNode("td", _hoisted_49, _toDisplayString(_ctx.translate('officeName')) + ": ", 1),
                                          _createElementVNode("td", _hoisted_50, _toDisplayString(_ctx.modalUserData.officeName), 1)
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("tr", null, [
                                      _createElementVNode("td", _hoisted_51, _toDisplayString(_ctx.translate('phone')) + ": ", 1),
                                      _createElementVNode("td", _hoisted_52, _toDisplayString(_ctx.modalUserData.phone), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _createElementVNode("td", _hoisted_53, _toDisplayString(_ctx.translate('createdDate')) + ": ", 1),
                                      _createElementVNode("td", _hoisted_54, _toDisplayString(new Date(_ctx.modalUserData.createdAt)
                                  .toLocaleString('en-GB')
                                  .split(',')[0]), 1)
                                    ]),
                                    _hoisted_55,
                                    _createElementVNode("h5", _hoisted_56, _toDisplayString(_ctx.translate('mostpublished')) + ": ", 1),
                                    _createElementVNode("tr", null, [
                                      _createElementVNode("td", _hoisted_57, _toDisplayString(_ctx.translate('mostAdArea')) + ": ", 1),
                                      _createElementVNode("td", _hoisted_58, _toDisplayString(_ctx.modalUserData.area), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _createElementVNode("td", _hoisted_59, _toDisplayString(_ctx.translate('mostAdType')) + ": ", 1),
                                      _createElementVNode("td", _hoisted_60, _toDisplayString(_ctx.modalUserData.adsType), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _createElementVNode("td", _hoisted_61, _toDisplayString(_ctx.translate('mostAdsPropertyCategory')) + ": ", 1),
                                      _createElementVNode("td", _hoisted_62, _toDisplayString(_ctx.modalUserData.propertyCategory), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _createElementVNode("td", _hoisted_63, _toDisplayString(_ctx.translate('mostAdsPropertyType')) + ": ", 1),
                                      _createElementVNode("td", _hoisted_64, _toDisplayString(_ctx.modalUserData.propertyType), 1)
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ]),
                          _hoisted_65
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              "cell-areaName": _withCtx(({ row: ad }) => [
                _createTextVNode(_toDisplayString(ad.areaName), 1)
              ]),
              "cell-propertyCategory": _withCtx(({ row: ad }) => [
                _createTextVNode(_toDisplayString(ad.propertyCategory), 1)
              ]),
              "cell-propertyType": _withCtx(({ row: ad }) => [
                _createTextVNode(_toDisplayString(ad.propertyType), 1)
              ]),
              "cell-size": _withCtx(({ row: ad }) => [
                _createTextVNode(_toDisplayString(ad.size), 1)
              ]),
              "cell-price": _withCtx(({ row: ad }) => [
                _createTextVNode(_toDisplayString(ad.priceTitle
              ? ad.priceTitle
              : new Intl.NumberFormat('en-US').format(ad.price)), 1)
              ]),
              "cell-adsType": _withCtx(({ row: ad }) => [
                _createTextVNode(_toDisplayString(ad.adsType), 1)
              ]),
              "cell-createdAt": _withCtx(({ row: ad }) => [
                _createTextVNode(_toDisplayString(ad.createdAt), 1)
              ]),
              "cell-statusId": _withCtx(({ row: ad }) => [
                (ad.statusId == 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_66, _toDisplayString(ad.statusTitle), 1))
                  : (ad.statusId == 1)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_67, _toDisplayString(ad.statusTitle), 1))
                    : (ad.statusId == 2)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_68, _toDisplayString(ad.statusTitle), 1))
                      : (ad.statusId == 3)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_69, _toDisplayString(ad.statusTitle), 1))
                        : (ad.statusId == 4)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_70, _toDisplayString(ad.statusTitle), 1))
                          : _createCommentVNode("", true)
              ]),
              "cell-actions": _withCtx(({ row: ad }) => [
                _createElementVNode("div", _hoisted_71, [
                  _createElementVNode("a", {
                    href: "#",
                    class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1",
                    onClick: _withModifiers(($event: any) => (_ctx.updateAd(ad.id)), ["prevent"])
                  }, [
                    _createElementVNode("span", _hoisted_73, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/art/art005.svg" })
                    ])
                  ], 8, _hoisted_72),
                  _createElementVNode("a", {
                    href: "#",
                    class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1",
                    onClick: _withModifiers(($event: any) => (_ctx.editAd(ad.id)), ["prevent"])
                  }, [
                    _createElementVNode("span", _hoisted_75, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen019.svg" })
                    ])
                  ], 8, _hoisted_74),
                  _createElementVNode("a", {
                    href: "#",
                    class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1",
                    onClick: _withModifiers(($event: any) => (_ctx.viewAd(ad.id)), ["prevent"])
                  }, [
                    _createElementVNode("span", _hoisted_77, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen021.svg" })
                    ])
                  ], 8, _hoisted_76),
                  _createElementVNode("a", {
                    href: "#",
                    class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1",
                    onClick: _withModifiers(($event: any) => (_ctx.editSeo(ad.id)), ["prevent"])
                  }, [
                    _createElementVNode("span", _hoisted_79, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen064.svg" })
                    ])
                  ], 8, _hoisted_78),
                  _createElementVNode("div", _hoisted_80, [
                    _withDirectives(_createElementVNode("input", {
                      disabled: ad.isApproved,
                      class: "form-check-input",
                      style: {"border":"2px solid #3f4254"},
                      type: "checkbox",
                      value: ad.id,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.checkedAds) = $event))
                    }, null, 8, _hoisted_81), [
                      [_vModelCheckbox, _ctx.checkedAds]
                    ])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["table-data", "table-header", "loading", "total", "onCurrentChange"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isModalOpen)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
          class: "modal-overlay"
        }, [
          _createElementVNode("div", {
            onClick: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["stop"])),
            class: "modal-content"
          }, [
            _createElementVNode("div", _hoisted_82, [
              _createElementVNode("label", _hoisted_83, _toDisplayString(_ctx.translate('rejection')), 1),
              _createElementVNode("div", _hoisted_84, [
                _createVNode(_component_Multiselect, {
                  modelValue: _ctx.rejection,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.rejection) = $event)),
                  requierd: false,
                  label: "rejectReason",
                  trackBy: "rejectReason",
                  searchable: true,
                  canDeselect: false,
                  options: _ctx.rejectReasons,
                  placeholder: _ctx.translate('selectRejectReasons'),
                  valueProp: "rejectReason",
                  noResultsText: _ctx.translate('noResultsFound'),
                  onInput: _ctx.updaterejectionNote
                }, null, 8, ["modelValue", "options", "placeholder", "noResultsText", "onInput"])
              ])
            ]),
            _createElementVNode("div", _hoisted_85, [
              _createElementVNode("label", _hoisted_86, _toDisplayString(_ctx.translate('rejectionNote')), 1),
              _createElementVNode("div", _hoisted_87, [
                _createVNode(_component_Field, {
                  as: "textarea",
                  name: "rejectionNote",
                  autocomplete: "off",
                  class: "form-control form-control-lg form-control-solid",
                  placeholder: _ctx.translate('rejectionNote'),
                  modelValue: _ctx.rejectionNote,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.rejectionNote) = $event))
                }, null, 8, ["placeholder", "modelValue"]),
                _createElementVNode("div", _hoisted_88, [
                  _createElementVNode("div", _hoisted_89, [
                    _createVNode(_component_ErrorMessage, { name: "rejectionNote" })
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_90, [
              _createElementVNode("button", {
                class: "btn btn-white",
                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
              }, "clsoe"),
              _createElementVNode("button", {
                ref: "bulkRejButton",
                class: "btn btn-primary",
                onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.rejectAds && _ctx.rejectAds(...args)))
              }, " save ", 512)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}